<template>
  <div class="uploader">
    <label :for="componentId">
      <div class="pg-uploader" :style="hasBorder" v-loading="uploading" v-bind:class="{dragging : dragover}" @drop.prevent="onDrop" @dragover.prevent="onDragOver" @dragleave="onDragEnd">
        <div v-if="!uploadedFile||dragover">
          <i v-if="!uploadedFile||dragover" class="el-icon-picture avatar-uploader-icon"></i>
          <span v-if="!dragover && !uploading" class="description"><br>{{fieldName}}</span>
          <span v-if="dragover && !uploading" class="description">Drop to upload</span>
        </div>

        <div v-if="uploadedFile && uploadedFile.contentType.includes('image') && !dragover" class="preview" v-bind:style="{backgroundImage : 'url(' + uploadedFile.path + ')' }">
          <el-button @click="removeFile" class="remove-file" type="text">
            <i class="el-icon-circle-close"></i>
          </el-button>
        </div>

        <div v-if="uploadedFile && uploadedFile.contentType.includes('video') && !dragover" class="preview">
          <video width="400">
            <source :src="uploadedFile.path" :type="uploadedFile.contentType">
            Your browser does not support HTML5 video.
          </video>
          <el-button @click="removeFile" class="remove-file" type="text">
            <i class="el-icon-circle-close"></i>
          </el-button>
        </div>

      </div>
    </label>
    <input @change="onChange" type="file" :id="componentId" class="hidden-file" />
  </div>
</template>

<script>
export default {
  name: 'Uploader',
  props: {
    image: {
      type: Object,
      required: false
    },
    fieldName: {
      type: String,
      required: true
    }
  },
  computed: {
    hasBorder () {
      if (this.uploadedFile && this.uploadedFile.contentType.includes('image') && !this.dragover) {
        return { border: 'none' }
      } else {
        return {}
      }
    }
  },
  data () {
    return {
      imageUrl: '',
      dragover: false,
      file: null,
      uploadedFile: null,
      uploading: false,
      componentId: this._uid
    }
  },
  methods: {
    onChange (file) {
      var realFile = file.target.files[0]
      if (realFile) {
        this.file = realFile
        this.upload()
      }
    },
    onDrop (ev) {
      this.file = event.dataTransfer.files[0]
      this.dragover = false
      this.upload()
    },
    onDragOver (ev) {
      this.dragover = true
    },
    onDragEnd (ev) {
      this.dragover = false
    },
    removeFile () {
      this.uploadedFile = null
      this.$emit('input', null)
      this.$emit('fileRemove')
    },
    upload () {
      this.uploading = true
      this.$emit('uploadStart')

      var data = new FormData()
      data.append('file', this.file)

      this.$http.post(this.$api.files, data).then(res => {
        this.uploadedFile = res.data
        this.$emit('input', res.data.id)
        this.$emit('uploadSuccess', res.data)
      }, res => {
        this.$message.error('Could not upload file - try again!')
        this.$emit('uploadError', res.data)
      }).then(() => {
        this.uploading = false
        this.file = null
      })
    }
  },
  mounted () {
    this.uploadedFile = this.image
  },
  watch: {
    image () {
      this.uploadedFile = this.image
    }
  }
}
</script>

<style lang="scss">

.hidden-file {
  display: none;
}

.uploader {
  width: 180px;
  height: 180px;
}

.pg-uploader {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed white;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    overflow: visible;
    cursor: pointer;
    height: 100%;
    width: 100%;

    .description {
      position: relative;
      color: white;
      text-transform: uppercase;
    }

    .uploader-icon {
      font-size: 28px;
      color: #008fcc !important;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    &:hover {

      .uploader-icon {
        color: #008fcc;
      }
    }

    &.dragging {
      border-color: #FF9900;
      background-color:#262931;
    }

    .preview {
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-size: 90% auto;
      background-position: center center;
      background-color: white;

      .remove-file {
        text-align: right;
        position: absolute;
        right: 10px;
        top: -5px;
        color: #d9d9d9;

        &:hover {
          color: white;
        }
      }
    }

}

.el-upload-dragger {
  width: auto;
  height: auto;
  background-color: transparent;
}

.avatar-uploader .el-upload {
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #008fcc;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: white;
  width: 100%;
  height: 100%;
  margin-top: 40%;
  margin-bottom: 10px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.small-uploader {
  width: 100px;
  height: 100px;
  .avatar-uploader-icon  {
    margin-top: 30%;
    margin-bottom: 0px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/Uploader.vue